import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { saveObjArr, getObjArr, clearLocalStorage } from '@blade/common/utils/localstorage';
import { EStatus, EPhotoStatus } from '@blade/common/interfaces/upload';
import SparkMD5 from 'spark-md5';
import CryptoJs from 'crypto-js';
import { FileUploadModule } from '@blade/common/store/file-upload';
import { handleError } from '@blade/common/utils/handle-error';
import { EType } from '@blade/common/interfaces/user-group';
import { userMapping } from '@blade/common/constants/user-mode';
import EventBus, { EventKeys } from '@blade/common/utils/eventbus';
// enum LibraryTypeEnum {
//   // 人像库
//   PORTRAIT_LIBRARY = 'PORTRAIT_LIBRARY',
//   // 车辆库
//   AUTO_FEATURE = 'AUTO_FEATURE',
// }
let default_1 = class default_1 extends Vue {
    libType;
    uploadFiles = [];
    currId = '';
    cancel;
    status = EStatus.INITIAL;
    CHUNKSIZE = 1024 * 1024 * 5; // 1MB
    currFile;
    uploadProgress = 0;
    fileName = '';
    target = null;
    completed = [];
    calculatingMd5 = false;
    currIndex = 0;
    newXmlHttpRequest;
    currlib;
    isReUpload = false;
    taskId = '';
    radioOption = '';
    popInstance;
    fileExtension = '';
    type = '0'; // pass|alert
    created() { }
    mounted() {
        const res = this.$route.path;
        const meta = res.split('/').filter((item) => item);
        if (meta[0] && meta[0] === 'monitor') {
            this.type = '1';
        }
        EventBus.$on(EventKeys.FileUpload, this.onFileUpload);
        EventBus.$on(EventKeys.UploadPause, this.handlePause);
        EventBus.$on(EventKeys.ReUpload, this.handleReUpload);
    }
    handleReUpload(id) {
        this.taskId = id;
        console.log('id:', id);
        this.isReUpload = true;
        this.$refs.fileInput.click();
        FileUploadModule.updateUploadPer(0);
    }
    onInputClick(e) {
        console.log('file:', e);
        e.target.value = '';
    }
    onFileUpload(ev) {
        // this.isReUpload = false;
        // const res = JSON.parse(ev);
        // console.log('res:', res);
        // this.currlib = res;
        this.$refs.fileInput.click();
    }
    httpRequest(file, fileList) {
        console.log(file, fileList);
    }
    handleFileChange(e) {
        console.log('e:', e);
        this.target = e.target;
        const uploadedFile = this.target.files;
        console.log('uploaded file:', uploadedFile);
        if (!uploadedFile)
            return;
        this.fileName = uploadedFile[0].name;
        const res = this.checkLarge(this.fileName);
        const isGuest = this.currlib?.libraryType === 0 && this.currlib.personGroup === EType.GUEST;
        if (!res && isGuest) {
            this.$elmessage(this.$t('error').toString());
            return;
        }
        this.fileExtension = this.fileName.substring(this.fileName.lastIndexOf('.'), this.fileName.length) || this.fileName;
        this.status = EStatus.WAIT;
        this.handleStart(uploadedFile[0]);
    }
    checkLarge(filename) {
        const fileFormat = /^(\d{8}_\d{8})/;
        const first8 = filename.substring(0, 8);
        const following8 = filename.substring(9, 17);
        const res = Number(following8) - Number(first8) > 0 && fileFormat.test(this.fileName);
        return res;
    }
    openNotiboard() {
        this.popInstance = this.$elnotify({
            title: this.$t('upload1').toString(),
            message: `${this.$t('upload2').toString()} ${this.fileName}`,
            duration: 0,
            customClass: 'notify-wrapper',
        });
    }
    async initialize() {
        try {
            await this.initPortraitLib();
            await FileUploadModule.initializeFile('default');
            EventBus.$emit(EventKeys.FileInitialized);
            await this.handleUpload();
        }
        catch (e) {
            FileUploadModule.updateUploading(false);
            // eslint-disable-next-line no-unused-expressions
            this.popInstance?.close();
            handleError(e);
        }
    }
    async initPortraitLib() {
        console.log('init portrait');
        try {
            if (!this.isReUpload) {
                if (this.currlib?.radioOption === '1' && this.currlib?.libraryType === 0) {
                    await FileUploadModule.initPortraitLibPass({
                        libName: this.currlib?.inputValue || '',
                        type: this.currlib?.personGroup || EType.USER,
                    });
                }
                else if (this.currlib?.radioOption === '1' && this.currlib?.libraryType === 1) {
                    await FileUploadModule.initPortraitLibAlert(this.currlib?.inputValue || '');
                }
                else if (this.currlib?.radioOption === '2') {
                    await FileUploadModule.updateLibrayId(this.currlib.inputValue);
                }
            }
            const res = await FileUploadModule.createTask({
                fileMd5: this.currFile.hash,
                fileName: this.fileName,
                isRestartTask: this.isReUpload,
                taskId: this.taskId,
                libraryType: this.libType,
                userMode: userMapping[this.currlib?.personGroup || EType.USER] || 0,
            });
            const objectName = res.taskId ? res.taskId + this.fileExtension : this.fileName;
            FileUploadModule.updateObjectName(objectName);
        }
        catch (e) {
            throw e;
        }
    }
    async handleStart(rawFile) {
        FileUploadModule.updateUploading(true);
        this.openNotiboard();
        rawFile.chunkList = [];
        this.uploadProgress = 0;
        this.currFile = rawFile;
        this.calculatingMd5 = true;
        const res = await this.computeMD5(this.currFile);
        this.calculatingMd5 = false;
        if (!res) {
            return;
        }
        this.initialize();
    }
    checkCompleted() {
        const res = this.getChunkStorage(this.currFile.hash);
        if (!res) {
            return false;
        }
        FileUploadModule.updateUploadId(res.uploadId);
        FileUploadModule.updateObjectName(res.objectName);
        this.currFile.chunkList = this.currFile.chunkList.map((file, index) => {
            const storageUploaded = res.chunk.find((item) => item.part_number === index.toString());
            console.log('part_info:', file.part_info);
            if (storageUploaded.uploaded) {
                this.completed.push(storageUploaded.part_info);
            }
            return {
                ...file,
                uploaded: storageUploaded.uploaded,
            };
        });
        return true;
    }
    async handleUpload() {
        if (!this.currFile)
            return;
        if ([EStatus.DONE, EStatus.ERROR].includes(this.status)) {
            return;
        }
        console.log('status:', this.status);
        if (this.status === EStatus.RESUME) {
            this.uploadFileProgress();
        }
        this.status = EStatus.UPLOADING;
        this.currFile.chunkList = this.currFile.chunkList.map((file, index) => {
            console.log('uploaded:', file.uploaded);
            return {
                fileHash: this.currFile.hash,
                part_number: index.toString(),
                chunk: file.chunk,
                size: file.size,
                sha256_hex: file.sha256_hex,
                index: index,
                uploaded: file.uploaded,
            };
        });
        console.log('curr file:', this.currFile);
        await this.uploadChunks();
    }
    getChunkStorage(name) {
        return getObjArr(name);
    }
    computeMD5(file) {
        return new Promise((resolve) => {
            const fileReader = new FileReader();
            const blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
            let currentChunk = 0;
            let chunkSize = 0;
            let chunks = 0;
            console.log('file:', file.size);
            if (file.size < this.CHUNKSIZE) {
                chunkSize = file.size;
                chunks = 1;
            }
            else {
                chunkSize = this.CHUNKSIZE;
                chunks = Math.ceil(file.size / chunkSize);
            }
            const spark = new SparkMD5.ArrayBuffer();
            fileReader.onload = async function (e) {
                const currChunk = e.target.result;
                spark.append(currChunk);
                const wa = CryptoJs.lib.WordArray.create(currChunk);
                const sha256 = CryptoJs.SHA256(wa).toString();
                file.chunkList.push({
                    chunk: new Blob([currChunk]),
                    sha256_hex: sha256,
                    size: currChunk.byteLength,
                });
                currentChunk++;
                if (currentChunk < chunks) {
                    loadNext();
                }
                else {
                    const hash = spark.end();
                    file.hash = hash;
                    console.log('hash:', file.hash);
                    resolve(true);
                }
            };
            fileReader.onerror = function () {
                console.warn('oops, something went wrong.');
                resolve(false);
            };
            function loadNext() {
                let start = currentChunk * chunkSize;
                let end = start + chunkSize >= file.size ? file.size : start + chunkSize;
                fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
            }
            loadNext();
        });
    }
    async uploadChunks() {
        const chunkData = this.currFile.chunkList;
        const requestDataList = chunkData.map((item, index) => {
            const data = {
                registry_id: FileUploadModule.registry_id,
                bucket_name: FileUploadModule.bucket_name,
                object_name: FileUploadModule.object_name,
                part_number: item.index + 1,
                upload_id: FileUploadModule.upload_Id,
                content_md5_base64: '',
                content_body: item.chunk,
                content_length: item.size,
                content_sha256_hex: '',
                uploaded: item.uploaded || false,
            };
            return data;
        });
        console.log('chunk data:', chunkData);
        try {
            const registry_id = FileUploadModule.registry_id;
            const upload_id = FileUploadModule.upload_Id;
            for (let i = 0; i < requestDataList.length; i++) {
                const { content_body, uploaded, ...rest } = requestDataList[i];
                if (uploaded) {
                    this.uploadFileProgress();
                    continue;
                }
                this.newXmlHttpRequest = new SendBinaryData(`/upload/v1/registries/${registry_id}/multipart_upload/${upload_id}`, JSON.stringify(rest), 'PUT');
                const res = await this.newXmlHttpRequest.sendData(content_body);
                const stringifyResponse = res.target.response;
                const part = JSON.parse(stringifyResponse);
                this.completed.push(part.part_info);
                this.currFile.chunkList[i].uploaded = true;
                this.uploadFileProgress();
            }
            this.finishUpload();
            this.status = EStatus.DONE;
            this.$elmessage.success(`${this.$t('successUpload')} ${this.target.files[0].name}`);
            clearLocalStorage(this.currFile.hash);
        }
        catch (error) {
            handleError(error);
            await FileUploadModule.updateTask({
                state: EPhotoStatus.UPLOAD_INTERRUPTED,
            });
        }
        finally {
            this.clearUpload();
            FileUploadModule.updateUploading(false);
            // eslint-disable-next-line no-unused-expressions
            this.popInstance?.close();
        }
    }
    async finishUpload() {
        try {
            await FileUploadModule.finishUpload(this.completed);
            await FileUploadModule.updateTask({
                state: EPhotoStatus.UPLOAD_COMPLETED,
            });
            await FileUploadModule.batchTask();
            this.$emit('upload-success');
        }
        catch (e) {
            console.log('finish:', e);
        }
    }
    async handleRemove() {
        localStorage.removeItem(this.currFile.hash);
        this.clearUpload();
        this.newXmlHttpRequest && this.newXmlHttpRequest.abort();
        await FileUploadModule.deleteUpload();
    }
    handlePause() {
        this.status = EStatus.PAUSE;
        this.newXmlHttpRequest && this.newXmlHttpRequest.abort();
    }
    handleResume() {
        this.status = EStatus.RESUME;
        this.handleUpload();
    }
    getUploaded(currIndex) {
        const res = this.currFile.chunkList.find((item) => item.index === currIndex);
        return res?.uploaded || false;
    }
    uploadFileProgress() {
        if (this.currFile) {
            console.log('uploaded:', this.currFile);
            const res = this.currFile.chunkList.reduce((acc, cur) => {
                if (cur.uploaded) {
                    return acc + 1;
                }
                return acc;
            }, 0);
            const currUploaded = res < this.currFile.chunkList.length ? (res / this.currFile.chunkList.length).toFixed(2) : 1;
            this.uploadProgress = currUploaded * 100;
            FileUploadModule.updateUploadPer(Math.ceil(this.uploadProgress / 2));
        }
    }
    async beforeDestroy() {
        if (this.status === EStatus.UPLOADING || this.status === EStatus.WAIT) {
            this.newXmlHttpRequest && this.newXmlHttpRequest.abort();
            await FileUploadModule.updateTask({ state: EPhotoStatus.UPLOAD_INTERRUPTED });
        }
        EventBus.$off('fileUpload', this.onFileUpload);
        EventBus.$off('uploadPause', this.handlePause);
        EventBus.$off('reUpload', this.handleReUpload);
    }
    saveUploaded(chunkData) {
        const chunkStorage = chunkData.map(({ part_number, uploaded }) => {
            const currNum = parseInt(part_number);
            const find = this.completed.find((item) => parseInt(item.part_number) === currNum + 1);
            return { part_number, uploaded, part_info: find || {} };
        });
        saveObjArr('chunk' + this.currFile.hash, FileUploadModule.bucket_name, FileUploadModule.object_name, FileUploadModule.upload_Id, chunkStorage);
    }
    clearUpload() {
        this.currFile = undefined;
        this.status = EStatus.INITIAL;
        this.fileName = '';
        if (this.target) {
            this.target.value = '';
        }
        this.completed = [];
    }
    // 设置libraryid
    setLibraryid(libraryid) {
        FileUploadModule.updateLibrayId(libraryid);
    }
};
__decorate([
    Prop()
], default_1.prototype, "libType", void 0);
default_1 = __decorate([
    Component({
        name: 'BatchUploader',
        i18n: {
            messages: {
                'en-us': {
                    file5mb: 'Please use zip file and file size need to be larger than 5MB',
                    upload1: 'Upload File',
                    upload2: 'Uploading File',
                    error: 'Please follow the file format of startdate_enddate_xx.zip to upload, eg 20200101_20200201_xx.zip',
                    successUpload: 'Successfully Uploaded',
                },
                zh: {
                    file5mb: '请用zip文件不能小于5MB',
                    upload1: '上传文件',
                    upload2: '正在上传',
                    error: '请遵循开始日期_结束日期_xx.zip命名, 示例20200101_20200201_xx.zip',
                    successUpload: '成功上传',
                },
            },
        },
    })
], default_1);
export default default_1;
class SendBinaryData {
    oReq;
    constructor(url, headers, method) {
        this.oReq = new XMLHttpRequest();
        this.oReq.open(method, url);
        this.oReq.setRequestHeader('Content-Meta', headers);
        this.oReq.setRequestHeader('Content-Type', 'application/octet-stream');
    }
    sendData(data) {
        return new Promise((resolve, reject) => {
            if (!this.oReq) {
                reject(new Error());
            }
            this.oReq.onload = function (oEvent) {
                resolve(oEvent);
            };
            this.oReq.onerror = function (oEvent) {
                reject(oEvent);
            };
            this.oReq.onabort = function (oEvent) {
                console.log('abort');
                reject(new Error('abort'));
            };
            this.oReq.send(data);
        });
    }
    abort() {
        this.oReq && this.oReq.abort();
    }
}
